// JsFromRoutes CacheKey ef0a5303e05e1d307484e4c46e5380ca
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  exportStandalone: definePathHelper('post', '/attachments/export_standalone'),
  embed: definePathHelper('post', '/attachments/:record_type/:record_id/embed'),
}
